/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { ConfigService } from '../configuration/config.service'

@Injectable({
  providedIn: 'root',
})
export class ExtRedirectToLoginAndSecurityGuard {
  private document = inject(Document)
  private configService = inject(ConfigService)

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    this.document.location.href = this.configService.getExternalUrl({
      identifier: 'access',
      language: this.configService.getUrlLocale().split('_')[0] + '-' + this.configService.getUrlCountry().toUpperCase(),
      suffix: 'login-and-security',
    })

    return false
  }
}
